import type { Theme } from '@mui/material/styles';
import type { OpenXAgentTableColumn } from './types.ts';

// popovers are portaled to the body, so they need to sit above the OpenX Agent modal (z-index 10000)
export const popoverSx = { zIndex: 10001 } as const;

export const cardSx = {
  backgroundColor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '8px',
} as const;

export const fieldSx = {
  height: 36,
  boxSizing: 'border-box',
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
  typography: 'body1',
  '&.Mui-focused': { borderColor: 'primary.main' },
} as const;

export const panelRootSx = { py: 2, px: 3, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 } as const;

const GRID_GAP_SPACING = 2;

// Up to `maxColumns` equal columns; once a column would get narrower than `minColumnWidth` the items wrap onto more rows.
export const responsiveGridSx = (maxColumns: number, minColumnWidth: number) => (theme: Theme) =>
  ({
    display: 'grid',
    gap: GRID_GAP_SPACING,
    gridTemplateColumns: `repeat(auto-fill, minmax(max(${minColumnWidth}px, calc((100% - ${theme.spacing(
      (maxColumns - 1) * GRID_GAP_SPACING
    )}) / ${maxColumns})), 1fr))`,
  }) as const;

export const getTableMinWidth = (columns: OpenXAgentTableColumn[], autoColumnMinWidth: number) =>
  columns.reduce((sum, { width }) => sum + (width === 'auto' ? autoColumnMinWidth : Number.parseFloat(width)), 0);

export const tableResetSx = {
  borderCollapse: 'collapse',
  '& .MuiTableHead-root': { borderBottom: 0 },
  '& .MuiTableCell-root': {
    height: 'auto',
    p: 0,
    pr: 2,
    border: 0,
    fontSize: 12,
    lineHeight: '18px',
    color: 'text.primary',
    wordBreak: 'normal',
    verticalAlign: 'middle',
  },
} as const;
